export enum EstadoFacturaAnticipadaRecarga {
    Pendiente,
    Facturado,
    Disponible
}
